import { style } from '@vanilla-extract/css';
import { NEUTRAL_COLORS, nToPx, themeVars, toBorder } from '@tundr/theme';

export const fieldsetContainer = style({
  border: toBorder(themeVars.colors.neutrals.grey50),
  padding: nToPx(themeVars.space.x3, themeVars.space.x4, themeVars.space.x4),
  borderRadius: themeVars.radius.md,
  width: '100%',
  minWidth: 200,
  boxShadow: `5px 4px 1px 0px ${NEUTRAL_COLORS.grey40}`,
  backgroundColor: themeVars.colors.neutrals.grey10,
});

export const legendClass = style({
  display: 'flex',
  alignItems: 'center',
  padding: nToPx(2, themeVars.space.x2),
  fontWeight: themeVars.font.weight.bold,
  backgroundColor: themeVars.colors.neutrals.grey10,
  borderRadius: themeVars.radius.md,
  boxShadow: `2px -3px 1px 0px ${NEUTRAL_COLORS.grey30}`,
});

export const titleIconClass = style({
  marginRight: themeVars.space.x2,
  fontSize: themeVars.font.size.textLg,
});

export const fieldSetContentClass = style({
  padding: nToPx(0, themeVars.space.x12),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

export const fieldSetActionsClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: themeVars.space.x2,
  marginTop: themeVars.space.x6,
  marginBottom: themeVars.space.x4,
});
